import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DevLandingPublic from '@/components/dev-builder/DevLandingPublic';

// dev-builder-200: página pública SIN auth. Fetch crudo (no usa el axios `api`
// con interceptors de sesión) — mismo patrón que CarSitePublicPage.js.

export default function DevSitePublicPage() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setNotFound(false);
      try {
        const base = process.env.REACT_APP_BACKEND_URL || '';
        const res = await fetch(`${base}/api/dev-sites/${encodeURIComponent(slug)}/data`);
        if (!res.ok) {
          if (!cancelled) setNotFound(true);
          return;
        }
        const json = await res.json();
        if (!cancelled) setData(json);
      } catch {
        if (!cancelled) setNotFound(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [slug]);

  // El favicon NO puede resolverse declarativamente como el <title>: index.html
  // ya trae 3 <link rel="icon"> ESTÁTICOS con `sizes` explícito (favicon.ico,
  // favicon-32x32.png, favicon-16x16.png) que viven FUERA del árbol de React
  // (HTML crudo, presente antes de que React monte) -- React 19 solo hoistea/
  // gestiona lo que ÉL renderiza, así que un <link> dictado por JSX aquí se
  // AGREGA a esos 3, no los reemplaza, y el navegador prefiere los que traen
  // `sizes` sobre el nuestro (que no lo tenía) -- por eso el título sí cambiaba
  // y el ícono no. Fix: quitar los 3 estáticos del DOM mientras esta pantalla
  // esté montada (dejando el nuestro como ÚNICO candidato, sin ambigüedad) y
  // devolverlos tal cual al desmontar.
  useEffect(() => {
    const faviconUrl = data?.landing?.hero?.favicon_url;
    if (!faviconUrl) return undefined;

    const staticIcons = Array.from(document.querySelectorAll('link[rel~="icon"]'));
    staticIcons.forEach((el) => el.remove());

    const ownLink = document.createElement('link');
    ownLink.setAttribute('rel', 'icon');
    ownLink.setAttribute('href', faviconUrl);
    document.head.appendChild(ownLink);

    return () => {
      ownLink.remove();
      staticIcons.forEach((el) => document.head.appendChild(el));
    };
  }, [data?.landing?.hero?.favicon_url]);

  if (loading) return <div className="p-8 text-center">Cargando...</div>;
  if (notFound || !data) return <div className="p-8 text-center text-gray-600">Landing no encontrada.</div>;

  const hero = data.landing?.hero || {};

  return (
    <>
      {/* El <title> SÍ funciona declarativo: es un único nodo, React 19 lo
          hoistea y reemplaza el de index.html sin ambigüedad posible (no hay
          "varios <title> compitiendo" como sí pasa con los <link rel=icon>
          de arriba). Va aquí -- ruta pública -- y NO en DevLandingPublic.js,
          que también se usa embebido (sin iframe) en el PreviewPane del
          editor: ahí correría dentro del árbol del admin y le robaría la
          pestaña a quien está editando. */}
      {hero.page_title && <title>{hero.page_title}</title>}
      <DevLandingPublic
        landing={data.landing}
        development={data.development}
        units={data.units || []}
        company={data.company || {}}
      />
    </>
  );
}
